import { Sprite, Texture, Rectangle } from "pixi.js";
import { Viewport } from "pixi-viewport";
import { IArtworkSprite } from "../../interfaces";

export class ArtworkSprite extends Sprite implements IArtworkSprite {
  public scaleFactor: number = 1;
  public isCentered: boolean = false;
  public radius: number = 0;

  constructor(texture: Texture | null = null) {
    // If texture is null, the sprite will be a blank placeholder until loadTexture() is called
    super(texture ?? Texture.WHITE);
  }

  /**
   * Checks if the sprite is currently within the viewport’s visible area.
   * This method uses the viewport’s getVisibleBounds() to determine if
   * the sprite's bounds intersect with the viewport area.
   *
   * @param viewport - The viewport instance.
   * @returns boolean - true if in view, false otherwise.
   */
  isInViewPoint(viewport: Viewport): boolean {
    const spriteBounds = this.getBounds(); // Global bounds of the sprite
    const visibleBounds: Rectangle = viewport.getVisibleBounds();

    // Check if sprite and viewport rectangles overlap
    const inHorizontalView =
      spriteBounds.x + spriteBounds.width >= visibleBounds.x &&
      spriteBounds.x <= visibleBounds.x + visibleBounds.width;

    const inVerticalView =
      spriteBounds.y + spriteBounds.height >= visibleBounds.y &&
      spriteBounds.y <= visibleBounds.y + visibleBounds.height;

    return inHorizontalView && inVerticalView;
  }
}
